let facetTranslations = {};
if (document.getElementById("algolia_translations")) {
  /*try {
		//facetTranslations = $.parseJSON( document.getElementById('algolia_translations').innerText );
	} catch (e) {
		console.log('[Algolia]: Error reading translations');
	}*/
  document.getElementById("algolia_translations").remove();
}

(function (algolia) {
  "use strict";
  algolia.translations = {
    core: {
      pages_result_title: {
        en: "Pages",
        fr: "Pages",
      },
      searchForProduct: {
        en: "Search for products",
        fr: "Recherche d'articles",
      },
      clearAll: {
        en: "Clear all",
        fr: "Tout effacer",
      },
      outOf: {
        en: "out of",
        fr: "de",
      },
      search_for: {
        en: "Search for",
        fr: "Rechercher pour",
      },
      no_match: {
        en: "No match for",
        fr: "Pas de correspondance pour",
      },
      noResult: {
        en: "No result for query",
        fr: "Aucun résultat pour votre demande",
      },
      width: {
        en: "Width",
        fr: "Largeur",
      },
      height: {
        en: "Height",
        fr: "Hauteur",
      },
      depth: {
        en: "Depth",
        fr: "Profondeur",
      },
      saved: {
        en: "Save",
        fr: "Économisez",
      },
      show: {
        en: "SHOW",
        fr: "Afficher",
      },
      hide: {
        en: "HIDE",
        fr: "Cacher",
      },
      showMore: {
        en: "Load more",
        fr: "Voir davantage",
      },
      showingStats_1: {
        en: "Showing",
        fr: "Voici les ",
      },
      showingStats_2: {
        en: "results for",
        fr: "résultats trouvés pour ",
      },
      showingStats_1_1: {
        en: "Showing 1 result for",
        fr: "Voici les 1 résultat pour ",
      },
      show_previous: {
        en: "Show previous results",
        fr: "Afficher les résultats précédents",
      },
      swatch_message: {
        en: "Available in more colours",
        fr: "Plus de couleurs offertes",
      },
    },
    sortOptions: {
      relevance: {
        en: "Relevance",
        fr: "Pertinence",
      },
      Popularity: {
        en: "Popularity",
        fr: "Popularité",
      },
      Price_desc: {
        en: "Price: High to low",
        fr: "Prix : Ordre décroissant",
      },
      Price_asc: {
        en: "Price: Low to high",
        fr: "Prix : Ordre croissant",
      },
    },
    facets: window.algoliafacets || {},
  };

  algolia.translation_helpers = {
    no_result_for: function (text, render) {
      return algolia.translations.core.noResult[algoliaLang] + render(text);
    },
    try_clear_or_change_input: function (text, render) {
      var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, "g");
      var html_tags = text.match(regex);
      if (algoliaLang == "en") {
        var noResultSolution =
          "Try " +
          render(html_tags[0]) +
          " clearing filters " +
          render(html_tags[1]) +
          " or " +
          render(html_tags[2]) +
          " changing your input " +
          render(html_tags[3]);
      } else {
        var noResultSolution =
          "Essayez " +
          render(html_tags[0]) +
          " de réinitialiser les filtres " +
          render(html_tags[1]) +
          " ou " +
          render(html_tags[2]) +
          " de modifier votre saisie " +
          render(html_tags[3]);
      }
      return noResultSolution;
    },

    outOf: function () {
      return (
        this.page * this.hitsPerPage +
        1 +
        "-" +
        Math.min((this.page + 1) * this.hitsPerPage, this.nbHits) +
        " " +
        algolia.translations.core.outOf[algoliaLang]
      );
    },

    translation: function (text, render) {
      return algolia.translations[render(text)];
    },
  };
})(window.algoliaShopify);
